<template>
  <!-- Footer -->
  <footer class="footer">
    <b-container>
      <div class="row footer-ad">
        <div class="hidden-xs"></div>
      </div>
      <b-container class="justify-content-md-center">
        <b-row align-h="center">
          <b-col cols="3"></b-col>
          <b-col cols="6">
            <b-row>
              <b-col><router-link to="students">Students</router-link></b-col>
              <b-col><router-link to="help">Help</router-link></b-col>
              <b-col><router-link to="games">Games</router-link></b-col>
              <b-col><router-link to="about">About</router-link></b-col>
            </b-row>
          </b-col>
          <b-col cols="3"></b-col>
        </b-row>
        <b-row class="copyright">
          <b-col>
            <img src="../assets/img/lplogo.png" alt="">
            © 2020 Planet Interactive, Inc. All Rights Reserved.
          </b-col>
        </b-row>
      </b-container>
    </b-container>
    <cookie-law theme="dark-lime"></cookie-law>

  </footer>
  <!-- Footer -->
</template>

<script>
import CookieLaw from 'vue-cookie-law'

export default {
  name: 'Footer',
  props: {
    msg: String
  },
  components: { CookieLaw }
}
</script>


<style scoped>

/* footer & copyright */

.footer {
  position:relative;
  background-color: #111;
  color: #fff;

  background-image:url("../assets/img/2016/lower_banner.png");
  background-size:100% auto;
  background-repeat:no-repeat;
  height:290px;
}

.footer ul {margin: 0; padding: 10; list-style: none; font-size: 12px}
.footer li {margin-left:10px; margin-right:10px;}
.footer a {color: #eee}
.footer a:hover {color: #fff}

.footer .footer-ad {
  min-height:40px;
  text-align:center;
  margin-top:40px;
}

.copyright {
  margin-top: 25px; 
  color: black;
  font-size: 12px;
}

</style>
